export enum ValidationError {
  Required = 'Required',
  Custom = 'Custom'
}
